import React from 'react'
import { Container, Column, Columns } from '@resurs/midas-react'
import { Redirect } from 'react-router'

import { getText } from '../../internal/TextLabels'
import Page from '../../internal/Page'

const Home = () => (
  <Page title={getText('home.dashboard')}>
    <Redirect to="/apply" />
    <Container>
      <Columns>
        <Column col12>{getText('home.dashboard')}</Column>
      </Columns>
    </Container>
  </Page>
)

export default Home
